import * as React from 'react'

function PauseIcon(props) {
    return (
        <svg width={14} height={17} viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width={3} height={17} rx={1.5} fill="white" />
            <rect x={9} width={3} height={17} rx={1.5} fill="white" />
        </svg>
    )
}

export default PauseIcon
